export default __webpack_public_path__ + "93a797a18b16153a528ea0981b019d76.svg";